import React, { useState } from 'react';

import Input from '../components/Input';

const EditableCell = (params) => {
  const [editing, setEditing] = useState(false);

  if (!editing && params.value == null) {
    return (
      <span
        onClick={() => setEditing(true)}
        className="flex h-full w-full cursor-pointer items-center">
        -
      </span>
    );
  }

  return <Input params={params} setEditing={setEditing} autoFocus={editing} />;
};

export const COLUMN_DEFS = [
  {
    field: 'payer.name',
    headerName: 'Payer',
    flex: 1
  },
  {
    field: 'allowable_amount_cents',
    headerName: 'Expected allowable amount',
    flex: 1,
    cellClass: 'no-border',
    cellStyle: { padding: '0' },
    cellRenderer: EditableCell
  },
  {
    field: 'adjustment_amount_cents',
    headerName: 'Expected adjustment amount',
    flex: 1,
    cellClass: 'no-border',
    cellStyle: { padding: '0' },
    cellRenderer: EditableCell
  }
];

export const DEFAULT_COLUMN_DEFS = { minWidth: 100 };

export const getAllowableAmountTooltip = (isDental) =>
  isDental
    ? "If 'Expected allowable amount' is edited, it will override the assumed fee schedule amount"
    : "If 'Expected allowable amount' is edited, it will override the assumed allowable amount, which is pulled from the Medicare fee schedule by default";

export const ALLOWABLE_AMOUNT_TEXT = 'Allowable amounts';
